import React, { Fragment, memo, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { Table, TableBody, TableCell, TableRow, TableHead } from "@mui/material";
import { Config } from "../../../Utils/Config";
import moment from "moment";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import { Row, Col } from "reactstrap";
import logo from "../../../Assets/Images/logo.png";
import OwnerDetailsPdf from './OwnerDetailsPdf';
import LoanDetailsPdf from './LoanDetailsPdf';
import { formatSeasonalityText, validateUrlElement } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";


let addr = "";
let elements;
let count = 0;
let calculatePage = [];
let pageNo = 3;
let ownerDetails_rows;
let loanDetails_rows;
let splittedArray;
let pageIndex = [];
let ownerDetailsPg = 0,
    debtDetailsPg = 0;
let ownerDetails_count;
let activityList = []

export const ExportProfile = memo((props) => {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const { id, lat, lng, key } = useParams();
  const navigate = useNavigate();
  const [profileInfo, setProfileInfo] = useState({});
  const [reportData, setReportData] = useState({
    profileDetails: [],
    amenitiesDetails: [],
    rentalDetails: [],
    ownerdetails: [],
    loandetails: []
  });

  let list = [];


  const getProfileInfo = () => {
    apiCommonTrigger("post",`${Config.API_URL}/rvparks/profilefordownload`, {
                     profileId: !parseInt(id) ? null : parseInt(id),
        latitude: !parseFloat(lat) || lat === "0" ? null : parseFloat(lat),
        longitude: !parseFloat(lng) || lng === "0" ? null : parseFloat(lng),
        securityKey: !key ? null : key
                })
      .then((res) => {
        if (res.status === 200) {
          elements = [];
          pageIndex = [];
          calculatePage = [];
          count = 0;

         
         
          ownerDetails_count = res.data.ownerdetails.length;
          let profile = res.data?.profile;
          if (profile) {
            if (profile.profilename !== null) {
              addr = profile.profilename;
            }
            if (profile.streetaddress1 !== null) {
              addr = addr + ", " + profile.streetaddress1;
            }
            if (profile.streetaddress2 !== null) {
              addr = addr + ", " + profile.streetaddress2;
            }
            if (profile.city !== null) {
              addr = addr + ", " + profile.city;
            }
            if (profile.statecode !== null) {
              addr = addr + ", " + profile.statecode;
            }
            if (profile.zipcode !== null) {
              addr = addr + ", " + profile.zipcode;
            }
          }

          if (res.data.ownerdetails.length > 0 && res.data.ownerdetails.length >= 4) {
           
            ownerDetails_rows = [
              ...Array(
                Math.ceil(
                  res.data.ownerdetails.length / 17
                )
              ),
            ];

            const ownerArr = [];
            let od = 0,
              k = 0;
            let inc = count;

            while (
              k < res.data.ownerdetails.length
            )
            {
              // 21 indicates no of lines in page
              const osize =
                k === 0 ? (inc > 17 ? inc - 17 : inc === 0 ? 17 : 17 - inc) : 17;
              
              ownerArr.push(
                res.data.ownerdetails.slice(
                  k,
                  k + osize
                )
              );
              od = (od + 1) % 2;
              k += osize;
            }
            for (var j = 0; j < ownerArr.length; j++){
              if (count === 0 || count > 16) {
                printPdfFull(
                  ownerArr[j],
                  "1",
                  "Ownership"
                );
              }
              else {
                printPartialPage(
                  ownerArr[j],
                  "1",
                  "Ownership"
                )
              }
            }

           
          }
          
          if (res.data.loandetails.length > 0 && res.data.loandetails.length >= 4) {
             
            count = 0;
            loanDetails_rows = [
              ...Array(
                Math.ceil(
                  res.data.loandetails.length / 10
                )
              ),
            ];

            const loanArr = [];
            let ld = 0,
              k = 0;
            let inc = count;

            while (
              k < res.data.loandetails.length
            )
            {
              const lsize = 
              k === 0 ? (inc > 10 ? inc - 10 : inc === 0 ? 10 : 10 - inc) : 10;
              
              loanArr.push(
                res.data.loandetails.slice(
                  k,
                  k + lsize
                )
              );

              ld = (ld + 1) % 2;
              k += lsize;
            
            }
            for (var j = 0; j < loanArr.length; j++){
              if (count === 0 || count > 10) {
                printPdfFull(
                  loanArr[j],
                  "2",
                  "Valuation & Debt"
                );
              }
              else {
                printPartialPage(
                  loanArr[j],
                  "2",
                  "Valuation & Debt"
                )
              }
            }

          }

          setProfileInfo({ ...profileInfo, profileInfo: res.data });
        
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  }

  const printPartialPage = (
    data,
    id,
    name
  ) => {
    
    let arrayLength =
      id === "1" ? 17 : id === "2" ? 10 : data.length + 3;
    count += arrayLength;

    calculatePage.push({
      id: id,
      count: count,
      name: name
    });
    
    let showHeader =
      calculatePage[calculatePage.length - 1].name === name ? false : true;
    calculatePage.push({
      id: id,
      count: count,
      name: name
    });

    if (pageIndex.indexOf(id) === -1) {
      pageIndex.push(id);
      if (id === "1") {
        ownerDetailsPg = pageNo;
      } else if (id === "2") {
        debtDetailsPg = pageNo;
      }
    }
    elements.push(
      
      <>
      <section>
    
            <div className="exportpdf-header">
          <div className="logo-pdf">
            <img src={logo} alt="RVParkIQ" />
          </div>
          <div className="address-pdf">
            <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>
          </div>
          <div className="clear"></div>
          <hr />
          </div> 
        
        {/* <div className="page-number">Page No: {pageNo}</div> */}
         <h5>{name}</h5> 
         
        { id === "1" ? (
          <OwnerDetailsPdf
            data={data}
          />
          ) :
          id === "2" ? (
            <LoanDetailsPdf
              data={data}
            />
          ):
            ""}
       
        </section>
        
      <div id="pbreak" className="page-break" /> 
       
        </>
    );
    if (count > 17) {
      count = 0;
    }
  }
  const printPdfFull = (
    data,
    id,
    name
  ) => {
    
    let pageBreak;
    if (id === "1") {
      count += 5;
      pageBreak = count > 17;
    } else if (id === "2") {
      count += 5;
      pageBreak = count > 10;
    }

    pageNo = pageNo + 1;
    calculatePage.push({
      id: id,
      count: count,
      name: name
    });

    if (pageIndex.indexOf(id) === -1) {
      pageIndex.push(id);
      if (id === "1") {
        ownerDetailsPg = pageNo;
      }
      else if (id === "2") {
        debtDetailsPg = pageNo;
      }
    }
    elements.push(
      <>
      <section>
          { ownerDetails_count <= 6  && name === 'Ownership' ?
            
           <br/> :
            <div className="exportpdf-header">
          <div className="logo-pdf">
            <img src={logo} alt="RVParkIQ" />
          </div>
          <div className="address-pdf">
            <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>
          </div>
          <div className="clear"></div>
          <hr />
          </div> 
            
         } 
        {/* <div className="page-number">Page No: {pageNo}</div> */}
        <div>
        <h5>{name}</h5>
        
        {id === "1" ? (
          <OwnerDetailsPdf
            data={data}
          />
            ) : id === "2" ? (
                <LoanDetailsPdf
                  data={data}
                />
        ) :""}
          {/* <br/> <br/> */}
          </div>
         
         
        </section>
        <div id="pbreak" className="page-break" /> 
        </>
    );
    count = count > 10 ? 0 : count;
  }

  useEffect(() => {
    getProfileInfo();
  }, []);

  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return null;

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const storelistProp = (infoDetails) => {
    list = [];
    let data = infoDetails;
    if (data !== null) {
      for (let i = 0; i < Object.keys(data).length; i++) {
        if (
          Object.values(data)[i] !== null &&
          Object.values(data)[i] !== undefined &&
          Object.values(data)[i] !== "" &&
          Object.keys(data)[i] !== "id" && Object.keys(data)[i] !== "rvProfileId"
        ) {
          let url, sourceURL;
          if (Object.keys(data)[i] === "website") {
            sourceURL =
              "http://" +
              Object.values(data)[i].toString().replace(/&amp;/gi, "&");
            url = new URL(sourceURL);
          }
          let tableHeader =
            Object.keys(data)[i] === "profilename"
              ? "Profile Name"
              : Object.keys(data)[i] === "facilitytypes"
                ? "Facility Types"
                :  Object.keys(data)[i] === "phone"
                  ? "Phone Number"
                  :  Object.keys(data)[i] === "fax"
                  ? "Fax"
                   :  Object.keys(data)[i] === "email"
                      ? "Email Address"  
                      :  Object.keys(data)[i] === "facebook"
                          ? "Facebook"  
                          :  Object.keys(data)[i] === "instagram"
                             ? "Instagram"
                             :  Object.keys(data)[i] === "rating"
                                ? "Google Rating"
                                   :  Object.keys(data)[i] === "landsize"
                                      ? "Land Size"
                                      :  Object.keys(data)[i] === "tollfree"
                                      ? "Toll-free"
                : Object.keys(data)[i] === "yearopened"
                  ? "Year Opened"
                  : Object.keys(data)[i] === "aceragefields"
                    ? "Acreage"
                    : Object.keys(data)[i] === "website"
                      ? "Website"
                      : Object.keys(data)[i] === "ownershiptype"
                        ? "Ownership Type"
                        : Object.keys(data)[i] === "profilename"
                          ? "Profile Name"
                          : Object.keys(data)[i] === "streetaddress1"
                            ? "Address"
                            : Object.keys(data)[i] === "streetaddress2"
                              ? "Address2"
                              : Object.keys(data)[i] === "seasonalityname"
                                ? "Seasonality"
                                : Object.keys(data)[i] === "onlinebookingstatus"
                                  ? "Online Booking Status"
                                  : Object.keys(data)[i] === "hookups"
                                    ? "Hookups"
                                    : Object.keys(data)[i] === "showersandbathrooms"
                                      ? "Shower and Bathrooms"
                                      : Object.keys(data)[i] === "dumpstation"
                                        ? "Dump Station"
                                        : Object.keys(data)[i] === "onsitepropane"
                                          ? "Onsite Propane"
                                          : Object.keys(data)[i] === "tentcamping"
                                            ? "Tent Camping"
                                            : Object.keys(data)[i] === "sitelockers"
                                              ? "Site Lockers"
                                              : Object.keys(data)[i] === "internetconnectivity"
                                                ? "Internet Connectivity"
                                                : Object.keys(data)[i] === "internetconnectivitypayment"
                                                  ? "Internet Connectivity Payment"
                                                  : Object.keys(data)[i] === "cellphoneconnectivity"
                                                    ? "Cellphone Connectivity"
                                                    : Object.keys(data)[i] === "lakeside"
                                                      ? "Lake-side"
                                                      : Object.keys(data)[i] === "swimmingpool"
                                                        ? "Swimming Pool"
                                                        : Object.keys(data)[i] === "fishing"
                                                          ? "Fishing"
                                                          : Object.keys(data)[i] === "rechall"
                                                            ? "Rec Hall"
                                                            : Object.keys(data)[i] === "cabins"
                                                              ? "Cabins"
                                                              : Object.keys(data)[i] === "cafe"
                                                                ? "Cafe"
                                                                : Object.keys(data)[i] === "sportscourts"
                                                                  ? "Sports Courts"
                                                                  : Object.keys(data)[i] === "petallowed"
                                                                    ? "Pet Allowed"
                                                                    : Object.keys(data)[i] === "golfcartrentals"
                                                                      ? "Golfcart Rentals"
                                                                      : Object.keys(data)[i] === "beachaccess"
                                                                        ? "Beach Access"
                                                                        : Object.keys(data)[i] === "attractionsdescriptions"
                                                                          ? "Attractions Descriptions"
                                                                          : Object.keys(data)[i] === "gameroomarcade"
                                                                            ? "GameRoom Arcade"
                                                                            : Object.keys(data)[i] === "rvsitedailypernight"
                                                                              ? "RV Site Daily Per Night"
                                                                              : Object.keys(data)[i] === "rvsiteweekly"
                                                                                ? "Rvsite Weekly"
                                                                                : Object.keys(data)[i] === "rvsitemonthly"
                                                                                  ? "Rvsite Monthly"
                                                                                  : Object.keys(data)[i] === "tentsitedailypernight"
                                                                                    ? "Tent Site Daily"
                                                                                    : Object.keys(data)[i] === "tentsiteweekly"
                                                                                      ? "Tent Site Weekly"
                                                                                      : Object.keys(data)[i] === "tentsitemonthly"
                                                                                        ? "Tent Site Monthly"
                                                                                        : Object.keys(data)[i] === "cabindailypernight"
                                                                                          ? "Cabin Daily Per Night"
                                                                                          : Object.keys(data)[i] === "cabinweekly"
                                                                                            ? "Cabin Weekly"
                                                                                            : Object.keys(data)[i] === "cabinmonthly"
                                                                                              ? "Cabin Monthly"
                                                                                              : Object.keys(data)[i] === "discountclubs"
                                                                                                ? "Discount Clubs"
                                                                                                : Object.keys(data)[i] === "discountdetail"
                                                                                                  ? "Discount Detail"
                                                                                                  : Object.keys(data)[i] === "bookingenginename"
                                                                                                    ? "Booking Engine Name"
                                                                                                    : Object.keys(data)[i] === "bookingengineurl"
                                                                                                      ? "Booking Engine Url"
                                                                                                      : Object.keys(data)[i] === "bookingform"
                                                                                                        ? "Booking Form"
                                                                                                        : Object.keys(data)[i] === "bookingphone"
                                                                                                          ? "Booking Phone"
                                                                                                          : Object.keys(data)[i] === "bookingemail"
                                                                                                            ? "Booking Email"
                                                                                                            : Object.keys(data)[i] === "checkin"
                                                                                                              ? "Check In"
                                                                                                              : Object.keys(data)[i] === "checkout"
                                                                                                                ? "Check Out"
                                                                                                                : Object.keys(data)[i] === "sourceurl"
                                                                                                                  ? "Source Url"
                                                                                                                  : Object.keys(data)[i] === "avgrvdailypernight"
                                                                                                                    ? "Avg RV Daily Per Night"
                                                                                                                    : Object.keys(data)[i] === "picnictable"
                                                                                                                      ? "Picnic Table"
                                                                                                                      : Object.keys(data)[i] === "firering"
                                                                                                                        ? "Fire Ring"
                                                                                                                        : Object.keys(data)[i] === "vehicularaccess"
                                                                                                                          ? "Vehicular Access"
                                                                                                                          : Object.keys(data)[i] === "electrichookup"
                                                                                                                            ? "Electric Hookup"
                                                                                                                            : Object.keys(data)[i] === "waterhookup"
                                                                                                                              ? "Water Hookup"
                                                                                                                              : Object.keys(data)[i] === "sewerhookup"
                                                                                                                                ? "Sewer Hookup"
                                                                                                                                : Object.keys(data)[i] === "noofsites"
                                                                                                                                  ? "No. of Spots"
                                                                                                                                  : Object.keys(data)[i];

          list.push(
            Object.keys(data)[i] !== "profileid" &&
              Object.keys(data)[i] !== "facilitytypeId" &&
              Object.keys(data)[i] !== "ownershipid" &&
              Object.keys(data)[i] !== "stateid" &&
              Object.keys(data)[i] !== "countryid" &&
              Object.keys(data)[i] !== "rvprofileid" &&
              Object.keys(data)[i] !== "streetaddress1" &&
              Object.keys(data)[i] !== "streetaddress2" &&
              Object.keys(data)[i] !== "city" &&
              Object.keys(data)[i] !== "statecode" &&
              Object.keys(data)[i] !== "countryname" &&
              Object.keys(data)[i] !== "zipcode" &&
              Object.keys(data)[i] !== "id" ? (
              <TableRow key={Object.keys}>
                <TableCell>{tableHeader}</TableCell>
                <TableCell>
                  {Object.keys(data)[i] === "website" ? validateUrlElement(Object.values(data)[i]) : (
                    Object.keys(data)[i] === "landsize" ?  Object.values(data)[i] === null ? '-' : Object.values(data)[i]  +  " Acres" : 
                    Object.keys(data)[i] === "seasonalityname" ?  formatSeasonalityText(Object.values(data)[i]) : Object.values(data)[i] 
                  )}
                </TableCell>
              </TableRow>
            ) : (
              ""
            )
          );
        }
      }
    }
    return list;
  };
  const getActivityList = (data) => {
    activityList = [];
    for (let index = 0; index < data.keys.length; index++) {
      let element = data.keys[index];
      activityList.push(
        <TableRow key={index}>
          <TableCell>{element}</TableCell>
          <TableCell>{data.activitylist[element] ? data.activitylist[element] : 'No'}</TableCell>
        </TableRow>
      )
    }
    return activityList;
  }
  return (
    <div className="profile-reports">
      <h1>Profile Report</h1>
      <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>

      {profileInfo?.profileInfo?.profile && Object.keys(profileInfo.profileInfo.profile).length > 0 ? <h5>Property Details</h5> : ""}

      <Table className="table-design">
        <TableBody>
          {profileInfo?.profileInfo?.profile && Object.keys(profileInfo.profileInfo.profile).length > 0 ? storelistProp(profileInfo.profileInfo.profile, "profile") : ""}
        </TableBody>
      </Table>
      {profileInfo?.profileInfo?.amenities && Object.keys(profileInfo.profileInfo.amenities).length > 0 ? <h5>Amenities and Features</h5> : ""}
      
      <section>
        <Table className="table-design">
          <TableBody>
            <TableRow>
              <TableCell>Additional Lodging</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.additionallodging !== null ? profileInfo.profileInfo.amenities.additionallodging : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Attractions Descriptions</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.attractionsdescriptions !== undefined && profileInfo.profileInfo.amenities.attractionsdescriptions !== null ? profileInfo.profileInfo.amenities.attractionsdescriptions : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Back In</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.backIn !== null ? profileInfo.profileInfo.amenities.backin : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Beach Access</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.beachaccess !== null ? profileInfo.profileInfo.amenities.beachaccess : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cabins</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.cabins !== null ? profileInfo.profileInfo.amenities.cabins : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cafe</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.cafe !== null ? profileInfo.profileInfo.amenities.cafe : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cellphone Connectivity</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.cellphoneconnectivity !== null ? profileInfo.profileInfo.amenities.cellphoneconnectivity : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Dog Parks</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.dogparks !== null ? profileInfo.profileInfo.amenities.dogparks : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Dump Station</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.dumpstation !== null ? profileInfo.profileInfo.amenities.dumpstation : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2}>Electric Hookup</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><span className="pdf-list-item">20 Amp</span></TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.eatwentyamp !== null ? profileInfo.profileInfo.amenities.eatwentyamp : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><span className="pdf-list-item">30 Amp</span></TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.ebthirtyamp !== null ? profileInfo.profileInfo.amenities.ebthirtyamp : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell><span className="pdf-list-item">50 Amp</span></TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.ecfiftyamp !== null ? profileInfo.profileInfo.amenities.ecfiftyamp : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>EV Charging</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.electriclevehiclecharging !== null ? profileInfo.profileInfo.amenities.electriclevehiclecharging : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Fire Ring</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.firering !== null ? profileInfo.profileInfo.amenities.firering : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Fishing</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.fishing !== null ? profileInfo.profileInfo.amenities.fishing : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>GameRoom Arcade</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.gameroomarcade !== null ? profileInfo.profileInfo.amenities.gameroomarcade : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Glamping</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.glamping !== null ? profileInfo.profileInfo.amenities.glamping : "-"}</TableCell>
            </TableRow>            
            <TableRow>
              <TableCell>Golfcart Rentals</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.golfcartrentals !== null ? profileInfo.profileInfo.amenities.golfcartrentals : "-"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* dont include extra items here, so that property details gets extra keys, page would fit perfectly */}
        {/* <div id="pbreak" className="page-break" /> */}


      </section>
      <div id="pbreak" className="page-break" />

      <section>
        <div className="exportpdf-header">
          <div className="logo-pdf">
            <img src={logo} alt="RVParkIQ" />
          </div>
          <div className="address-pdf">
            <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>
          </div>
          <div className="clear"></div>
          <hr />
        </div>
        {/* <div className="page-number">Page No: 2</div> */}
        <Table className="table-design market-summary-pdf two-col-table">
          <TableBody>
            <TableRow>
              <TableCell>Hookups</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.hookups !== null ? profileInfo.profileInfo.amenities.hookups : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Internet Connectivity</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.internetconnectivity !== null ? profileInfo.profileInfo.amenities.internetconnectivity : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Internet Connectivity Payment</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.internetconnectivitypayment !== null ? profileInfo.profileInfo.amenities.internetconnectivitypayment : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Lake-side</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.lakeside !== null ? profileInfo.profileInfo.amenities.lakeside : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Laundry Access</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.laundryaccess !== null ? profileInfo.profileInfo.amenities.laundryaccess : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Onsite Propane</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.onsitepropane !== null ? profileInfo.profileInfo.amenities.onsitepropane : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Pet Allowed</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.petallowed !== null ? profileInfo.profileInfo.amenities.petallowed : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Picnic Table</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.picnictable !== null ? profileInfo.profileInfo.amenities.picnictable : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Pull In Pull Through</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.pullinpullthrough !== null ? profileInfo.profileInfo.amenities.pullinpullthrough : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Rec Hall</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.rechall !== null ? profileInfo.profileInfo.amenities.rechall : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Self Service Car Wash</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.selfservicecarwash !== null ? profileInfo.profileInfo.amenities.selfservicecarwash : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Sewer Hookup</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.sewerhookup !== null ? profileInfo.profileInfo.amenities.sewerhookup : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Shower and Bathrooms</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.showersandbathrooms !== null ? profileInfo.profileInfo.amenities.showersandbathrooms : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Site Lockers</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.sitelockers !== null ? profileInfo.profileInfo.amenities.sitelockers : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Sports Courts</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.sportscourts !== null ? profileInfo.profileInfo.amenities.sportscourts : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Swimming Pool</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.swimmingpool !== null ? profileInfo.profileInfo.amenities.swimmingpool : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Tent Camping</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.tentcamping !== null ? profileInfo.profileInfo.amenities.tentcamping : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Vehicular Access</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.vehicularaccess !== null ? profileInfo.profileInfo.amenities.vehicularaccess : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Water Hookup</TableCell>
              <TableCell>{profileInfo && profileInfo.profileInfo !== undefined && profileInfo.profileInfo.amenities !== undefined && profileInfo.profileInfo.amenities.waterhookup !== null ? profileInfo.profileInfo.amenities.waterhookup : "-"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 ? <h5>Rate Details</h5> : ""}
        <Table className="table-design">
          <TableBody>
            <TableRow>
              <TableCell>Avg RV Daily Per Night</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgrvdailypernight !== null ? profileInfo.profileInfo.rentaldetail.avgrvdailypernight : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg Cabin Daily Per Night</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgcabindailypernight ? profileInfo.profileInfo.rentaldetail.avgcabindailypernight : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg Cabin  Per Week</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgcabinweekly ? profileInfo.profileInfo.rentaldetail.avgcabinweekly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg Cabin  Per Month</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgcabinmonthly ? profileInfo.profileInfo.rentaldetail.avgcabinmonthly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg RV Site  Per Week</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgrvsiteweekly ? profileInfo.profileInfo.rentaldetail.avgrvsiteweekly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg RV Site Per Month</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgrvsitemonthly ? profileInfo.profileInfo.rentaldetail.avgrvsitemonthly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg Tent Site Daily Per Night</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgtentsitedailypernight ? profileInfo.profileInfo.rentaldetail.avgtentsitedailypernight : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg Tent Site  Per Week</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgtentsiteweekly ? profileInfo.profileInfo.rentaldetail.avgtentsiteweekly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Avg Tent Site  Per Month</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.avgtentsitemonthly ? profileInfo.profileInfo.rentaldetail.avgtentsitemonthly : "-"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* dont include extra items here, so that property details gets extra keys, page would fit perfectly */}
        <div id="pbreak" className="page-break" />


      </section>
      <section>
      <div className="exportpdf-header">
          <div className="logo-pdf">
            <img src={logo} alt="RVParkIQ" />
          </div>
          <div className="address-pdf">
            <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>
          </div>
          <div className="clear"></div>
          <hr />
        </div>
        {/* <div className="page-number">Page No: 3</div> */}
        <Table className="table-design">
          <TableBody>

            <TableRow>
              <TableCell>Booking Email</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.bookingemail ? profileInfo.profileInfo.rentaldetail.bookingemail : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Booking Engine Name</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.bookingenginename ? profileInfo.profileInfo.rentaldetail.bookingenginename : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Booking Engine URL</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.bookingengineurl ? profileInfo.profileInfo.rentaldetail.bookingengineurl : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Booking Form</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.bookingform ? profileInfo.profileInfo.rentaldetail.bookingform : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Booking Phone</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.bookingphone ? profileInfo.profileInfo.rentaldetail.bookingphone : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cabind Daily Per Night</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.cabindailypernight ? profileInfo.profileInfo.rentaldetail.cabindailypernight : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cabins Per Week</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.cabinweekly ? profileInfo.profileInfo.rentaldetail.cabinweekly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Cabins Per Month</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.cabinmonthly ? profileInfo.profileInfo.rentaldetail.cabinmonthly : "-"}</TableCell>
            </TableRow>

            <TableRow>
            <TableCell>Check In</TableCell>
            <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.checkin ? profileInfo.profileInfo.rentaldetail.checkin : "-"}</TableCell>
          </TableRow>  
          <TableRow>
            <TableCell>Check Out</TableCell>
            <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.checkout ? profileInfo.profileInfo.rentaldetail.checkout : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Discount Clubs</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.discountclubs ? profileInfo.profileInfo.rentaldetail.discountclubs : "-"}</TableCell>
            </TableRow>
            <TableRow>
            <TableCell>Discount Detail</TableCell>
            <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.discountdetail ? profileInfo.profileInfo.rentaldetail.discountdetail : "-"}</TableCell>
          </TableRow>

            <TableRow>
              <TableCell>RV Site Daily Per Night</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.rvsitedailypernight ? profileInfo.profileInfo.rentaldetail.rvsitedailypernight : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>RV Site Per Week</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.rvsiteweekly ? profileInfo.profileInfo.rentaldetail.rvsiteweekly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>RV Site Per Month</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.rvsitemonthly ? profileInfo.profileInfo.rentaldetail.rvsitemonthly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Tent Site Daily Per Night</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.tentsitedailypernight ? profileInfo.profileInfo.rentaldetail.tentsitedailypernight : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Tent Site Per Week</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.tentsiteweekly ? profileInfo.profileInfo.rentaldetail.tentsiteweekly : "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Tent Site Per Month</TableCell>
              <TableCell>{profileInfo?.profileInfo?.rentaldetail && Object.keys(profileInfo.profileInfo.rentaldetail).length > 0 && profileInfo.profileInfo.rentaldetail.tentsitemonthly ? profileInfo.profileInfo.rentaldetail.tentsitemonthly : "-"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {profileInfo.profileInfo && profileInfo.profileInfo.ownerdetails !== undefined && profileInfo.profileInfo.ownerdetails.length !== 0 && profileInfo.profileInfo.ownerdetails.length >= 6 ? <div id="pbreak" className="page-break" /> : ""}
      </section>
   
 

      


      {profileInfo.profileInfo && profileInfo.profileInfo.ownerdetails !== undefined && profileInfo.profileInfo.ownerdetails.length !== 0 && profileInfo.profileInfo.ownerdetails.length <= 3 ?
       <>
        <section>
          {profileInfo.profileInfo && profileInfo.profileInfo.ownerdetails !== undefined && profileInfo.profileInfo.ownerdetails.length !== 0 ? <h5>OwnerShip</h5> : ""}
          
         <Table className="table-design ownership-table">
            {
              profileInfo.profileInfo &&
                profileInfo.profileInfo.ownerdetails !== undefined &&
                profileInfo.profileInfo.ownerdetails.length !== 0 ?
                <TableBody>
                  <TableRow>
                    <TableCell></TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>
                          Owner {idx + 1}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownertitle !== null ? data.ownertitle : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell> First Name</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerfirstname !== null ? data.ownerfirstname : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell> Last Name</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerlastname !== null ? data.ownerlastname : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Company Name</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.companyname !== null ? data.companyname : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Company Phone</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownercompanyphone !== null ? data.ownercompanyphone : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Company Email</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownercompanyemail !== null ? data.ownercompanyemail : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                      <TableCell>Website</TableCell>  
                      {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerwebsite !== null ? data.ownerwebsite : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Address Line 1</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerstreetaddress1 !== null ? data.ownerstreetaddress1 : "-"}</TableCell>
                      )
                    })}
                    </TableRow>
                    <TableRow>
                    <TableCell>Address Line 2</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerstreetaddress2 !== null ? data.ownerstreetaddress2 : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>City</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownercity !== null ? data.ownercity : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>State</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerstate !== null ? data.ownerstate : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                    <TableRow>
                      <TableCell>Fax</TableCell>
                      {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerfax !== null ? data.ownerfax : "-"}</TableCell>
                      )
                    })}
                    </TableRow>
                    <TableRow>
                      <TableCell>Toll-free</TableCell>
                      {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownertollfree !== null ? data.ownertollfree : "-"}</TableCell>
                      )
                    })}
                    </TableRow>
                    <TableRow>
                      <TableCell>Country</TableCell>
                      {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownercountry !== null ? data.ownercountry : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Zip Code</TableCell>
                    {profileInfo.profileInfo.ownerdetails.map((data, idx) => {
                      return (
                        <TableCell>{data.ownerzipcode !== null ? data.ownerzipcode : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                 
                </TableBody>
                : ""
            }
           
          </Table> 
    
       
         
          </section>           
           <div id="pbreak" className="page-break" />     
           </>       
        : ""} 


      {profileInfo.profileInfo && profileInfo.profileInfo.loandetails && profileInfo.profileInfo.loandetails !== undefined && profileInfo.profileInfo.loandetails.length !== 0  && profileInfo.profileInfo.loandetails.length <= 3? <section>
        {profileInfo.profileInfo && profileInfo.profileInfo.ownerdetails !== undefined && profileInfo.profileInfo.ownerdetails.length !== 0 ?
          <div className="exportpdf-header">
          <div className="logo-pdf">
            <img src={logo} alt="RVParkIQ" />
          </div>
          <div className="address-pdf">
            <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>
          </div>
          <div className="clear"></div>
          <hr />
        </div> : ""}
        {/* <div className="page-number">Page No: 4</div> */}
        { profileInfo.profileInfo && profileInfo.profileInfo.ownerdetails !== undefined && profileInfo.profileInfo.ownerdetails.length > 2 ? <div id="pbreak" className="page-break" /> : ""} 
        {profileInfo.profileInfo && profileInfo.profileInfo.loandetails !== undefined && profileInfo.profileInfo.loandetails.length !== 0 ? <h5>Valuation and Debt</h5> : ""}
        <Col md="12">
          <Table className="table-design debit-table">
            <TableBody>

              {profileInfo.profileInfo &&
                profileInfo.profileInfo.loandetails !== undefined &&
                profileInfo.profileInfo.loandetails.length !== 0 ?
                <Fragment>
                  <TableRow>
                    <TableCell></TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>Debt {idx + 1}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell> Improvement Value</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <>

                          <TableCell>{data.improvementvalue !== null ? Config.Currency + priceConversion(data.improvementvalue) : "-"}</TableCell>
                        </>
                      )
                    })

                    }

                  </TableRow>
                  <TableRow>
                    <TableCell>Interest Rate</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.interestrate !== null ? priceConversion(data.interestrate) + "%" : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Interest Type</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.interesttype !== null ? data.interesttype : "-"}</TableCell>
                      )
                    })}
                  </TableRow>

                  <TableRow>
                    <TableCell>Land Value</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.landvalue !== null ? Config.Currency + priceConversion(data.landvalue) : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Last Sale Date</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.lastsaledate !== null ? moment(data.lastsaledate).format('DD-MMM-YYYY') : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Last Sale Value</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.lastsalevalue !== null ? Config.Currency + priceConversion(data.lastsalevalue) : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Loan Amount</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.loanamount !== null ?  Config.Currency + priceConversion(data.loanamount) : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Loan Duration</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.loanduration !== null ? data.loanduration + " months" : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Loan Maturity Date</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.loanmaturitydate !== null ? moment(data.loanmaturitydate).format('DD-MMM-YYYY') : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  <TableRow>
                    <TableCell>Loan Origination Date</TableCell>
                    {profileInfo.profileInfo.loandetails.map((data, idx) => {
                      return (
                        <TableCell>{data.loanoriginationdate !== null ? moment(data.loanoriginationdate).format('DD-MMM-YYYY') : "-"}</TableCell>
                      )
                    })}
                  </TableRow>
                  
                
                    <>
                           <TableRow>
                                <TableCell>Loan Type</TableCell>
                                {profileInfo.profileInfo.loandetails.map((data, idx) => {
                                  return (
                                    <TableCell>{data.loantype !== null ? data.loantype : "-"}</TableCell>
                                  )
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>Market Value</TableCell>
                                {profileInfo.profileInfo.loandetails.map((data, idx) => {
                                  return (
                                    <TableCell>{data.marketvalue !== null ? Config.Currency + priceConversion(data.marketvalue) : "-"}</TableCell>
                                  )
                                })}
                              </TableRow>
        
                              <TableRow>
                                <TableCell>Status</TableCell>
                                {profileInfo.profileInfo.loandetails.map((data, idx) => {
                                  return (
                                    <TableCell>{data.status !== null ? data.status : "-"}</TableCell>
                                  )
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>Total Market Value</TableCell>
                                {profileInfo.profileInfo.loandetails.map((data, idx) => {
                                  return (
                                    <TableCell>{data.totalmarketvalue !== null ? Config.Currency + priceConversion(data.totalmarketvalue) : "-"}</TableCell>
                                  )
                                })}
                              </TableRow>
                    </>       
                                  
                </Fragment>
                : ""}
            </TableBody>
          </Table>

        </Col>

       {/* { profileInfo.profileInfo && profileInfo.profileInfo.ownerdetails !== undefined && profileInfo.profileInfo.ownerdetails.length !== 0 ? <div id="pbreak" className="page-break" /> : ""} */}
      </section>
        : " "}
  <div id="pbreak" className="page-break" />
  <section>
        {profileInfo.profileInfo && profileInfo.profileInfo.profileactivity !== null  ?
          <div className="exportpdf-header">
          <div className="logo-pdf">
            <img src={logo} alt="RVParkIQ" />
          </div>
          <div className="address-pdf">
            <p className="profile-address"><FmdGoodOutlinedIcon />{addr}</p>
          </div>
          <div className="clear"></div>
          <hr />
        </div> : ""}
        {/* <div className="page-number">Page No: 4</div> */}
        {profileInfo.profileInfo && profileInfo.profileInfo.profileactivity !== null ? <h5>Activities/Attractions</h5> : ""}
        <Col md="12">
          <Table className="table-design debit-table">
            <TableBody>

              {profileInfo.profileInfo && profileInfo.profileInfo.profileactivity !== null ?
                <Fragment>     
                      {getActivityList(profileInfo.profileInfo.profileactivity)}            
                </Fragment>
                : ""}
            </TableBody>
            </Table>
          </Col> 
       {/* { profileInfo.profileInfo && profileInfo.profileInfo.profileactivity !== null  ? <div id="pbreak" className="page-break" /> : ""} */}
        </section>

        {elements}
        
    </div>
  )
})
